<template lang="pug">
.register-row
  .register-group
    .register-key
      .left-side.d-flex
        span.key-name {{ keyName }}
        span.validation-label(v-if="required == true") 必須
        span.option-text.font-strong-color(v-if="optionText") {{ optionText }}
        slot(name="question")

    .register-value.form-input-checkboxes
      .d-flex.flex-wrap
        label.register-checkbox-label(v-for="option in options" :key="option.key" :style="option.style ? option.style : 'width: 120px;'")
          input(v-model="_value[option.key]" :name="name + '-' + option.key" :value="true" type="checkbox")
          //- クリックイベントはlabelに伝播するため、spanのクリックイベントは不要
          span.text(style="margin-left:0; margin-right: 0.5rem;") {{ option.label }}

    //- vee-validateでのエラー表示のために、非表示のinputを配置
    input(v-model="validationValue" :name="name" v-validate="validationRules" :data-vv-as="(validationKeyName) ? validationKeyName : keyName" style="display: none;")
    .error-messages(v-for="error in errors.collect(name)")
      label.error-message {{ error }}
      br
</template>

<script lang="ts">
import { Component, Prop, Inject, Vue } from "vue-property-decorator";
import { Validator } from "vee-validate";

/**
 * 複数選択チェックボックス入力要素コンポーネント
 *
 * - 複数の選択肢から複数選択をサポートする
 * - 既存の入力画面のスタイルが適用される
 * - バリデーターは親コンポーネントのものをInjectionして使用する
 */
@Component
export default class FormInputCheckboxes extends Vue {
  // 親コンポーネントのバリデーターをInjectionする
  @Inject("$validator") $validator!: Validator;

  /** 親コンポーネントでv-modelで指定したオブジェクト */
  @Prop({ required: true, type: Object })
  value!: { [key: string]: boolean };

  /**
   * リスト項目
   * key: v-modelオブジェクトのプロパティ名
   * label: 画面に表示するラベル
   */
  @Prop({ required: true })
  options!: Array<{ key: string; label: string; style: string }>;

  /** 項目名 */
  @Prop({ required: true, type: String })
  keyName!: string;

  /** 必須か */
  @Prop({
    default: () => {
      return false;
    },
    type: Boolean
  })
  required!: boolean;

  /** 説明文 */
  @Prop({
    default: () => {
      return "";
    },
    type: String
  })
  optionText!: string;

  /** name属性の値 */
  @Prop({ required: true, type: String })
  name!: string;

  /** veevalidateに渡すバリデーションルール */
  @Prop({
    default: ""
  })
  validationRules!: string;

  /** veevalidateに渡すバリデーション項目名 */
  @Prop({
    default: "",
    type: String
  })
  validationKeyName!: string;

  /** 子コンポーネントのv-modelでpropの値を指定してはいけないのでgetter/setterにする */
  get _value(): { [key: string]: boolean } {
    return this.value;
  }

  set _value(newValue: { [key: string]: boolean }) {
    this.$emit("input", newValue);
  }

  /** バリデーション用の算出プロパティ。いずれか一つでもtrueがあればtrueを返す */
  get validationValue(): boolean {
    if (!this.value) return false;
    return Object.values(this.value).some((v) => v === true);
  }
}
</script>

<style lang="scss" scoped>
@import "../../../styles/pc/_colors.scss";

.option-text {
  margin-left: 8px;
}

// 画像でセレクトボックスを表現するので、input要素自体は非表示にする
input[type="checkbox"] {
  display: none;

  // input要素の代わりに画像つきのspanにする
  // 選択しているか否かで画像を切り替える
  // for属性でcheckboxと紐づかせたspan要素のclickで、チェックボックスの状態が変更される
  & + span {
    // チェックボックス画像が全て表示されるように高さを指定する
    height: 46px;
    // チェックボックス画像が文字より大きく、文字が縦中央揃えに出来ないので、paddingで上下余白を取って位置調整
    padding: 6px 0 0 40px;
    background: url("../../../assets/login-checkbox-off.png") no-repeat left center;
    // チェックボックス画像のサイズを指定
    // 正方形なので要素の高さと同じになる
    background-size: 32px 32px;
  }
  &:checked + span {
    background: url("../../../assets/login-checkbox-on.png") no-repeat left center;
    // チェックボックス画像のサイズを指定
    // 正方形なので要素の高さと同じになる
    background-size: 32px 32px;
  }
}
</style>
